import { createFileRoute } from "@tanstack/react-router";
import { ComparisonPage } from "@/features/comparison/ComparisonPage";
import { i18n } from "@/lib/i18n";
import { buildHead } from "@/lib/seo/head";
import { siteUrl } from "@/lib/seo/siteUrl";

// `/comparison` (#164): a static, crawlable, no-3D page showing the 3D preview
// next to the real physical pillow. The link target for the viewer's legal-notice
// popover (#167) — "see comparisons" — so a buyer can judge the faithful-but-not-1:1
// accuracy for themselves. Brings its own marketing chrome (like the landing,
// ADR-0040), so Layout hands it the bare viewport.
//
// A public route (ADR-0053 §2): prerendered to static HTML with a real baked
// `<head>`. `ssr: true` opts it into build-time server rendering; its `head`
// builds the full SEO head model (title, description, absolute canonical, Open
// Graph, Twitter, Organization + WebSite JSON-LD) via the pure `buildHead` (#355)
// — the deterministic replacement for the old runtime `useComparisonHead`
// `useEffect`, which non-JS social scrapers never saw. No image and no price, so
// the Twitter card falls back to `summary` and no Product/Offer is emitted.
export const Route = createFileRoute("/comparison")({
  ssr: true,
  head: () =>
    buildHead({
      path: "/comparison",
      locale: i18n.resolvedLanguage ?? "pl",
      siteUrl: siteUrl(),
      content: {
        title: i18n.t("comparison:meta.title"),
        description: i18n.t("comparison:meta.description"),
      },
    }),
  component: ComparisonPage,
});
